import { clientFormParametersGeneration } from './clientFormParametersGeneration'
import { contactSaveParametersGeneration } from './IT/contactSaveParametersGeneration'

const parametersGeneratorByCountry = {
  it: contactSaveParametersGeneration,
}

export function generateContactParameters({ customerData, id, country, action, gryvChecklistCheckedTitles }) {
  const generator = parametersGeneratorByCountry[country]

  if (generator) {
    return generator({ customerData, id, country, action })
  }

  return clientFormParametersGeneration(customerData, id, country, action, gryvChecklistCheckedTitles)
}
